import React from 'react';
import EmbeddedApp from '../components/EmbeddedApp';
import { crmService } from '../services/api';

// Twenty CRM — окремий сервіс (crm/twenty), вбудовується в робочу область ЕРП.
// Бекенд видає одноразове посилання автологіну (акаунт у Twenty створюється автоматично).
function CrmPage() {
  return <EmbeddedApp title="CRM" getLoginUrl={crmService.twentyLogin} errorText="Не вдалося відкрити CRM." />;
}

export default CrmPage;
